export default "__VITE_ASSET__C$c$GAxS__"